import { testimonials } from "@/mocks/testimonials";

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32 bg-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="mb-16">
          <span className="inline-block text-[11px] font-label font-semibold text-foreground-500 bg-background-100 px-3 py-1.5 rounded-full uppercase tracking-wider mb-5">
            Community
          </span>
          <h2 className="font-heading text-[42px] md:text-[54px] leading-[1.08] text-foreground-950 font-bold tracking-[-0.02em]">
            Loved by Pandabuy
            <br />
            Spreadsheet Users
          </h2>
        </div>

        <div className="columns-1 md:columns-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.handle}
              className="break-inside-avoid mb-6 bg-background-50 rounded-2xl p-6 md:p-7 transition-all duration-300 hover:shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            >
              <div className="flex items-center gap-3 mb-5">
                <div
                  className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center font-label font-bold text-sm flex-shrink-0`}
                >
                  {t.initials}
                </div>
                <div>
                  <p className="text-[14px] font-label font-semibold text-foreground-900 leading-none">
                    {t.name}
                  </p>
                  <p className="text-[12px] text-foreground-500 font-body mt-1">
                    {t.handle}
                  </p>
                </div>
              </div>
              <p className="text-[14px] text-foreground-600 leading-relaxed font-body italic">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}